import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
/* eslint-disable no-underscore-dangle */
import { logger as loggerService } from '../logger';
var logger = loggerService.loggerIn('@sendfxcompany/js-utils/services/ads-manager');
var adsManagerInitialized;
var adsManagerId;
var scriptPromise;
var injectScript = function injectScript(_ref) {
  var id = _ref.id;
  var groupLogger = logger.groupIn('injectScript');
  window._tfa = window._tfa || [];
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.src = "//cdn.taboola.com/libtrc/unip/" + id + "/tfa.js";
    script.async = 1;
    script.id = 'tb_tfa_script';
    script.addEventListener('load', function () {
      groupLogger.log('injectScript finished loading script');
      resolve();
    });
    script.addEventListener('error', function (e) {
      groupLogger.log('injectScript failed loading script', e);
      reject(e.error);
    });
    document.head.appendChild(script);
  });
};
var awaitScript = function awaitScript() {
  return scriptPromise;
};
var getSingleton = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (adsManagerInitialized) {
              _context.next = 3;
              break;
            }
            logger.error('please initialize first the ads manager service before using it');
            return _context.abrupt("return", undefined);
          case 3:
            _context.next = 5;
            return awaitScript();
          case 5:
            if (!window._tfa) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return", window._tfa);
          case 7:
            return _context.abrupt("return", undefined);
          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getSingleton() {
    return _ref2.apply(this, arguments);
  };
}();
export var initializeAdsManager = function initializeAdsManager(_ref3) {
  var credentials = _ref3.credentials;
  if (adsManagerInitialized) {
    logger.error('you are trying to initialize ads manager and it is already initialized');
    return undefined;
  }
  adsManagerInitialized = true;
  adsManagerId = credentials.id;
  scriptPromise = injectScript({
    id: credentials.id
  });
  return scriptPromise;
};
export var initializeAdsManagerDisabled = function initializeAdsManagerDisabled() {
  adsManagerInitialized = true;
  scriptPromise = Promise.resolve();
  logger.log('ads manager is loaded but turned off');
  return scriptPromise;
};
export var trackPageView = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var ref;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getSingleton();
          case 2:
            ref = _context2.sent;
            if (ref) {
              ref.push({
                notify: 'event',
                name: 'PageView',
                id: adsManagerId
              });
              logger.log("tracking Page View on " + window.location.href);
            }
            return _context2.abrupt("return", undefined);
          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function trackPageView() {
    return _ref4.apply(this, arguments);
  };
}();